module.exports = __webpack_public_path__ + "aca4a80f563d146dd3501634e728130f.jpg";